import { render, staticRenderFns } from "./AdminOrderCreate.vue?vue&type=template&id=1f827dfe&scoped=true"
import script from "./AdminOrderCreate.vue?vue&type=script&lang=js"
export * from "./AdminOrderCreate.vue?vue&type=script&lang=js"
import style0 from "./AdminOrderCreate.vue?vue&type=style&index=0&id=1f827dfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f827dfe",
  null
  
)

export default component.exports